import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSonosComponent } from './simple-icons-sonos.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSonosComponent ],
    exports:      [ SimpleIconsSonosComponent ],
    bootstrap:    []
})
export class SimpleIconsSonosModule {}
